import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'h3-row',
  template: '<ng-content></ng-content>',
  styleUrls: ['./row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RowComponent {}
